import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BulkUpdateResponseDto, BulkUpdateUserDto, BulkUpload} from '@app/models/bulk-update/bulk-update.model';
import {FileAPIService} from './file.api.service';
import { ParentFilter } from '@app/models/api/parent-filter.model';

@Injectable({providedIn: 'root'})
export class BulkUploadAPIService {

  private readonly BASE_URL = '/api/bulk-upload';

  constructor(
      private http: HttpClient,
      private fileAPIService: FileAPIService
  ) {
  }

  getAllBulkUploadCreate(): Observable<Array<BulkUpload>> {
    const URL = `${this.BASE_URL}/create`;

    return this.http.get<Array<BulkUpload>>(URL);
  }

  // Whether the current company is externally provisioned (mapped to an external HR provisioner). The
  // bulk-create screen uses this to decide whether to show and require the External ID column.
  isCompanyProvisioned(): Observable<boolean> {
    const URL = `${this.BASE_URL}/provisioned`;

    return this.http.get<boolean>(URL);
  }

  userBulkCreateFromFile(file: File): Observable<HttpEvent<{}>> {
    const URL = `${this.BASE_URL}/create/file`

    return this.fileAPIService.saveFileWithProgress(file, URL);
  }

  userBulkUpdateFromFile(file: File): Observable<HttpEvent<{}>> {
    const URL = `${this.BASE_URL}/update/file`

    return this.fileAPIService.saveFileWithProgress(file, URL);
  }

  userBulkArchiveFromFile(file: File): Observable<HttpEvent<{}>> {
    const URL = `${this.BASE_URL}/archive/file`

    return this.fileAPIService.saveFileWithProgress(file, URL);
  }


  userBulkCreate(bulk: Array<BulkUpdateUserDto>): Observable<BulkUpdateResponseDto> {
    const URL = `${this.BASE_URL}/create`;
    return this.http.post<BulkUpdateResponseDto>(URL, bulk);
  }

  userBulkUpdate(bulk: Array<BulkUpdateUserDto>): Observable<BulkUpdateResponseDto> {
    const URL = `${this.BASE_URL}/update`;
    return this.http.post<BulkUpdateResponseDto>(URL, bulk);
  }

  exportAllUsersToXLSX(parentFilter: ParentFilter): Observable<any> {
    const URL = `${this.BASE_URL}/export`;
    return this.http.post(URL, parentFilter, {responseType: 'blob'});
  }
}
